export default __webpack_public_path__ + "static/media/photo--lg--misc-1.ae59fdea.jpg";